module.exports = __webpack_public_path__ + "img/icon_up.9461fede.svg";